import { Outlet, Link } from "react-router-dom";

export default function Root() {
    return (
      <>
        <div id="sidebar">
          <h1>Experiments</h1>
          <nav>
            <ul>
              <li>
                <Link to={`/recipe`}>Pizza Margherita recipe</Link>
              </li>
            </ul>
          </nav>
        </div>
        <div id="detail"><Outlet /></div>
      </>
    );
  }